export default __webpack_public_path__ + "static/media/ecosystem.6a6d4a37.jpg";